import {
  ParticipantModel,
  DashboardFilterModel,
  DashboardCollectionModel,
  CompanyCollectionModel,
  GridFilter,
  DashboardLookups,
  CompanyStatusModel,
  SimpleLookupModel,
  CompanyFollowupStatusModel,
  TransferCompanyModel,
  WorkshopModel,
  FileDownloadModel,
} from "@/core/models";
import { HttpService, DownloadService, Utils } from "@/core/services";

export const CompanyService = {
  filterCompanies(filter: GridFilter & GridFilter) {
    return HttpService.filterData<CompanyCollectionModel, GridFilter>("/companies/filter", filter);
  },
  getParticipants(workshopId: number) {
    return HttpService.getData<ParticipantModel[]>(`/companies/${workshopId}/participants`);
  },
  getDashboardLookups() {
    return HttpService.getData<DashboardLookups>("companies/dashboard/lookups");
  },
  dashboardFilter(filter: GridFilter & DashboardFilterModel) {
    return HttpService.filterData<DashboardCollectionModel, DashboardFilterModel>(
      "/companies/dashboard/filter",
      filter,
    );
  },
  getStatusById(companyId: number) {
    return HttpService.getData<CompanyStatusModel>(`/companies/${companyId}/status`);
  },
  getFollowUpStatuses() {
    return HttpService.getData<SimpleLookupModel[]>("/companies/followup/status");
  },
  getFollowUpStatus(companyId: number) {
    return HttpService.getData<CompanyFollowupStatusModel>(`/companies/followup/status/${companyId}`);
  },
  updateFollowUpStatus(model: CompanyFollowupStatusModel) {
    return HttpService.putModel("/companies/followup/status/update", model);
  },
  getCounties() {
    return HttpService.getData<SimpleLookupModel[]>("companies/counties");
  },
  async transferClient(model: TransferCompanyModel) {
    const result = await HttpService.putModel("companies/transfer/workshop", model);
    return result.data as WorkshopModel;
  },
  async downloadFollowUpReport(companyId: number) {
    const response: FileDownloadModel = await HttpService.getData<FileDownloadModel>(
      `companies/followup/${companyId}/download`,
    );
    const blob = new Blob([Utils.getArrayBuffer(atob(response.data))], { type: response.contentType });
    DownloadService.download(blob, response.fileName);
    return response;
  },
  updateSkillsConsultant(companyId: number, skillsConsultantId?: number) {
    return HttpService.put(`companies/${companyId}/skillsConsultant/${skillsConsultantId}`);
  },
};
